module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "club-wrapper"
  }, [_c('div', {
    staticClass: "centered city-addition"
  }, [_c('draggable', {
    attrs: {
      "options": {
        disabled: _vm.editableClub !== null
      }
    },
    model: {
      value: (_vm.clubsObject),
      callback: function($$v) {
        _vm.clubsObject = $$v
      },
      expression: "clubsObject"
    }
  }, _vm._l((_vm.clubsObject), function(club) {
    return _c('span', {
      staticClass: "city-wrapper",
      on: {
        "click": function($event) {
          return _vm.handleGetClub(club.id)
        }
      }
    }, [(_vm.editableClub !== club.id) ? _c('router-link', {
      key: club.id,
      staticClass: "city-title",
      class: _vm.$route.params.id === club.id || !_vm.$route.params.id && _vm.clubs[0].id === club.id ? 'is-active' : '',
      attrs: {
        "to": {
          name: 'FinancialClub',
          params: {
            id: club.id
          }
        }
      }
    }, [_vm._v(_vm._s(club.city) + "\n        ")]) : _c('span', {
      staticClass: "edit-city-wrapper"
    }, [_c('a', {
      staticClass: "delete hide-edit-city",
      on: {
        "click": function($event) {
          return _vm.toggleEditClub(club.id)
        }
      }
    }), _vm._v(" "), _c('b-input', {
      staticClass: "edit-city-input",
      model: {
        value: (_vm.newClubCity),
        callback: function($$v) {
          _vm.newClubCity = $$v
        },
        expression: "newClubCity"
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "apply-icon is-medium",
      attrs: {
        "src": "/static/img/icons/apply.svg"
      },
      on: {
        "click": _vm.handleUpdateFinancialClubs
      }
    })], 1), _vm._v(" "), _c('img', {
      staticClass: "edit-icon",
      attrs: {
        "src": "/static/img/icons/edit.svg"
      },
      on: {
        "click": function($event) {
          return _vm.toggleEditClub(club.id)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), (!_vm.cityAdditionVisible) ? _c('span', {
    staticClass: "button-wrapper city-addition-wrapper",
    on: {
      "click": _vm.toggleCityAddition
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить город\n    ")]) : _vm._e(), _vm._v(" "), (_vm.cityAdditionVisible) ? _c('b-field', {
    staticClass: "city-addition-input"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Введите название города"
    },
    model: {
      value: (_vm.cityName),
      callback: function($$v) {
        _vm.cityName = $$v
      },
      expression: "cityName"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "city-addition-button is-primary button",
    on: {
      "click": _vm.handleAddCity
    }
  }, [_vm._v("Добавить")]), _vm._v(" "), _c('span', {
    staticClass: "city-addition-button is-warning button",
    on: {
      "click": _vm.toggleCityAddition
    }
  }, [_vm._v("Отмена")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.clubObject) ? _c('div', {
    staticClass: "club"
  }, [_c('div', {
    staticClass: "club-header-wrapper columns",
    style: (_vm.headerStyle)
  }, [_c('div', {
    staticClass: "column logo-wrapper"
  }, [_c('div', {
    staticClass: "rounded-photo-wrapper club-photo centered",
    style: (_vm.logoContainerStyle)
  }, [(!_vm.clubObject.logo) ? _c('div', {
    on: {
      "click": _vm.handleLoadLogoImage
    }
  }, [_c('span', [_vm._v("Загрузить лого представительства")])]) : _c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteClubLogoImage(_vm.clubObject.id)
      }
    }
  })]), _vm._v(" "), _c('input', {
    ref: "loadLogoImage",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhotoLogoImage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "club-header column"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "По каким днями и где встречаемся"
    },
    on: {
      "change": _vm.handleUpdateFinancialClub
    },
    model: {
      value: (_vm.clubObject.description),
      callback: function($$v) {
        _vm.$set(_vm.clubObject, "description", $$v)
      },
      expression: "clubObject.description"
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Условия, начало встречи, атмосфера"
    },
    on: {
      "change": _vm.handleUpdateFinancialClub
    },
    model: {
      value: (_vm.clubObject.conditions),
      callback: function($$v) {
        _vm.$set(_vm.clubObject, "conditions", $$v)
      },
      expression: "clubObject.conditions"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "centered is-full-width"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handLoadClubPhoto
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Загрузить фото")]), _vm._v(" "), _c('input', {
    ref: "loadBackgroundPhoto",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.handleLoadClubBackgroundPhoto
    }
  })])], 1)]), _vm._v(" "), (!_vm.clubObject.announcement) ? _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddAnnouncement
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить срочное объявление\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.clubObject.financialClubMembers.length) ? _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "link members-link",
    on: {
      "click": _vm.showMembers
    }
  }, [_vm._v("Просмотреть список заявок")])]) : _vm._e(), _vm._v(" "), (_vm.clubObject.announcement) ? _c('div', {
    staticClass: "announcement"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteClubAnnouncement(_vm.clubObject.id)
      }
    }
  }), _vm._v(" "), _c('b-field', {
    staticClass: "title"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок объявления"
    },
    on: {
      "change": _vm.handleUpdateFinancialClub
    },
    model: {
      value: (_vm.clubObject.announcement.title),
      callback: function($$v) {
        _vm.$set(_vm.clubObject.announcement, "title", $$v)
      },
      expression: "clubObject.announcement.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Текст объявления"
    },
    on: {
      "change": _vm.handleUpdateFinancialClub
    },
    model: {
      value: (_vm.clubObject.announcement.description),
      callback: function($$v) {
        _vm.$set(_vm.clubObject.announcement, "description", $$v)
      },
      expression: "clubObject.announcement.description"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("Период размещения объявления на сайте")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "placeholder": "c"
    },
    on: {
      "change": _vm.announcementDateChanged
    },
    model: {
      value: (_vm.announcement.start),
      callback: function($$v) {
        _vm.$set(_vm.announcement, "start", $$v)
      },
      expression: "announcement.start"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "placeholder": "по"
    },
    on: {
      "change": _vm.announcementDateChanged
    },
    model: {
      value: (_vm.announcement.end),
      callback: function($$v) {
        _vm.$set(_vm.announcement, "end", $$v)
      },
      expression: "announcement.end"
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('a', {
    staticClass: "button is-info",
    on: {
      "click": _vm.handleAddMeeting
    }
  }, [_vm._v("+ Добавить встречу")])]), _vm._v(" "), _c('div', {
    staticClass: "columns meetings is-multiline"
  }, _vm._l((_vm.clubObject.meetings), function(meeting) {
    return _c('Meeting', {
      key: meeting.id,
      attrs: {
        "meeting": meeting
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "map-container"
  }, [_c('h2', {
    staticClass: "has-text-centered"
  }, [_vm._v("Укажите адрес на карте")]), _vm._v(" "), _c('gmap-map', {
    staticStyle: {
      "height": "350px"
    },
    attrs: {
      "center": _vm.center,
      "options": {
        scrollwheel: false
      },
      "zoom": 15
    },
    on: {
      "click": _vm.selectAddress
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": true
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('div', {
    staticClass: "button delete-pin",
    on: {
      "click": _vm.deletePin
    }
  }, [_vm._v("Удалить метку")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "columns club-information"
  }, [_c('div', {
    staticClass: "column is-two-thirds editor-container"
  }, [_c('b-field', {
    attrs: {
      "label": "Обсуждаем в дружеской обстановке"
    }
  }, [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "id": "talks"
    },
    model: {
      value: (_vm.talks),
      callback: function($$v) {
        _vm.talks = $$v
      },
      expression: "talks"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleLoadPhoto
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("\n          Добавить логотип организатора. Форматы: .png, .jpeg\n        ")]), _vm._v(" "), _c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, _vm._l((_vm.clubObject.logos), function(logo) {
    return _c('div', {
      staticClass: "column is-one-quarter"
    }, [_c('div', {
      staticClass: "logo-wrapper"
    }, [_c('img', {
      staticClass: "delete-icon",
      attrs: {
        "src": "/static/img/icons/delete.svg"
      },
      on: {
        "click": function($event) {
          return _vm.deleteSponsorLogo(logo)
        }
      }
    }), _vm._v(" "), (!logo.id) ? _c('img', {
      attrs: {
        "src": "/upload/photos/" + logo
      }
    }) : _c('img', {
      attrs: {
        "src": logo.base64photo
      }
    })])])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "column additional-information"
  }, [_c('b-field', {
    attrs: {
      "label": "Название места"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Введите название места"
    },
    on: {
      "change": _vm.handleUpdateFinancialClub
    },
    model: {
      value: (_vm.clubObject.placeName),
      callback: function($$v) {
        _vm.$set(_vm.clubObject, "placeName", $$v)
      },
      expression: "clubObject.placeName"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Где проходит"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Введите адресс"
    },
    on: {
      "change": _vm.handleUpdateFinancialClub,
      "blur": function($event) {
        return _vm.getAddress()
      }
    },
    model: {
      value: (_vm.clubObject.address),
      callback: function($$v) {
        _vm.$set(_vm.clubObject, "address", $$v)
      },
      expression: "clubObject.address"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Доп. информация (где парковка, сколько стоит)"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "textarea"
    },
    on: {
      "change": _vm.handleUpdateFinancialClub
    },
    model: {
      value: (_vm.clubObject.additionalInformation),
      callback: function($$v) {
        _vm.$set(_vm.clubObject, "additionalInformation", $$v)
      },
      expression: "clubObject.additionalInformation"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Ссылка на место проведения клуба"
    }
  }, [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.urlEditorToolbar,
      "id": "place-url"
    },
    model: {
      value: (_vm.placeUrl),
      callback: function($$v) {
        _vm.placeUrl = $$v
      },
      expression: "placeUrl"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('b-field', {
    staticClass: "benefits",
    attrs: {
      "label": "Кому будут полезны встречи"
    }
  }, [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.urlEditorToolbar,
      "id": "createdFor"
    },
    model: {
      value: (_vm.createdFor),
      callback: function($$v) {
        _vm.createdFor = $$v
      },
      expression: "createdFor"
    }
  })], 1)], 1), _vm._v(" "), _c('h2', {
    staticClass: "has-text-centered"
  }, [_vm._v("Постоянные спикеры")]), _vm._v(" "), _c('div', {
    staticClass: "speakers columns is-multiline"
  }, _vm._l((_vm.clubObject.clubSpeakers), function(speaker) {
    return _c('div', {
      key: speaker.id,
      staticClass: "is-one-third column"
    }, [_c('Speaker', {
      attrs: {
        "speaker": speaker
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper centered",
    on: {
      "click": function($event) {
        return _vm.handleAddSpeaker()
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("\n        Добавить спикера\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddClubPhoto
    }
  }, [_c('input', {
    ref: "loadClubPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.clubPhotoAdded
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("\n        Добавить фото из финансового клуба\n      ")])]), _vm._v(" "), (_vm.clubObject.photos.length) ? _c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.clubObject.photos), function(photo) {
    return _c('swiper-slide', {
      key: photo
    }, [_c('div', {
      staticClass: "centered"
    }, [(!photo.id) ? _c('img', {
      attrs: {
        "src": "/upload/photos/" + photo
      }
    }) : _c('img', {
      attrs: {
        "src": photo.base64photo
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "button is-danger delete-club-photo",
      on: {
        "click": function($event) {
          return _vm.deleteClubPhoto(photo)
        }
      }
    }, [_vm._v("\n            Удалить\n          ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('div', {
    staticClass: "button save-content",
    on: {
      "click": function($event) {
        return _vm.handleSaveFinancialClib(_vm.clubObject)
      }
    }
  }, [_vm._v("\n        СОХРАНИТЬ\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "columns has-text-centered club-footer"
  }, [_c('div', {
    staticClass: "column is-one-third delete-club",
    on: {
      "click": function($event) {
        return _vm.deleteClub(_vm.clubObject.id)
      }
    }
  }, [_vm._v("Удалить")]), _vm._v(" "), _c('div', {
    staticClass: "column hide"
  }, [_c('b-switch', {
    staticClass: "hide-from-site",
    on: {
      "change": _vm.handleUpdateFinancialClub
    },
    model: {
      value: (_vm.clubObject.isHidden),
      callback: function($$v) {
        _vm.$set(_vm.clubObject, "isHidden", $$v)
      },
      expression: "clubObject.isHidden"
    }
  }, [_vm._v("\n          Скрыть с сайта\n        ")])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.clubObject) ? _c('el-dialog', {
    staticClass: "webinar-dialog",
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "club-members"
  }, [_c('span', {
    staticClass: "club-members-count"
  }, [_vm._v("\n        Количество заявок: " + _vm._s(_vm.clubObject.financialClubMembers.length) + "\n      ")]), _vm._v(" "), _c('table', {
    staticClass: "club-members-table"
  }, [_c('thead', [_c('tr', [_c('td', {
    staticClass: "name"
  }, [_vm._v("Имя")]), _vm._v(" "), _c('td', {
    staticClass: "lastname"
  }, [_vm._v("Фамилия")]), _vm._v(" "), _c('td', {
    staticClass: "email"
  }, [_vm._v("Email")]), _vm._v(" "), _c('td', {
    staticClass: "phone"
  }, [_vm._v("Телефон")]), _vm._v(" "), _c('td', {
    staticClass: "date"
  }, [_vm._v("Дата заявки")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.clubObject.financialClubMembers), function(member) {
    return _c('tr', [_c('td', {
      staticClass: "name"
    }, [_vm._v(" " + _vm._s(member.name) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "lastname"
    }, [_vm._v(" " + _vm._s(member.lastname) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "email"
    }, [_vm._v(" " + _vm._s(member.email) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "phone"
    }, [_vm._v(" " + _vm._s(member.phone))]), _vm._v(" "), _c('td', {
      staticClass: "date"
    }, [_vm._v(" " + _vm._s(_vm._f("filterDate")(member.date)))]), _vm._v(" "), _c('td', {
      staticClass: "delete-member"
    }, [_c('img', {
      staticClass: "delete-icon",
      attrs: {
        "src": "/static/img/icons/delete.svg"
      },
      on: {
        "click": function($event) {
          return _vm.deleteClubMember(member.id)
        }
      }
    })])])
  }), 0)])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-035a11ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/FinancialClub.vue
// module id = 883
// module chunks = 0